import { CounterpartyType } from '@/constants/CounterpartyType';

export enum TaxEventSortField {
    EVENT_DATE = "EVENT_DATE",
    AMOUNT = "AMOUNT",
    CREATED_AT = "CREATED_AT",
    UPDATED_AT = "UPDATED_AT"
}

export default class TaxEventFilter {
    // Filters
    dateFrom: string | null = null;
    dateTo: string | null = null;
    isPaid: boolean | null = null;
    taxTypeId: number | null = null;
    customerId: number | null = null;
    customerType: CounterpartyType | null = null;
    createdById: number | null = null;
    lastModifiedById: number | null = null;

    // Pagination
    pageNumber = 1; // Frontend pagination usually starts with 1, will subtract 1 manually if needed, wait backend expects 0-indexed page for Pageable.
    pageSize = 20;

    // Sorting
    sortBy: TaxEventSortField = TaxEventSortField.CREATED_AT;
    sortDirection: "ASC" | "DESC" = "DESC";
}
